<app-header></app-header>

<!-- Hero section -->
<owl-carousel-o [options]="customOptions" class="owl-btn-center-lr hero-slider-one" id="home">
    <ng-template carouselSlide *ngFor="let slide of slideStore">
        <!-- Slider Item -->
        <div class="section-fullscreen bg-image bg-overlay" style="background-image: url('{{slide.image}}')">
            <div class="section-xl bg-dark-03">
                <div class="container text-center pt-5">
                    <div class="row g-4">
                        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 z-index-1">
                            <h3 class="fw-normal mb-3 text-white">{{slide.subtitle}}</h3>
                            <h1 class="text-white mb-md-4 fw-bold display-2">{{slide.title}}</h1>
                            <a class="btn btn-primary py-md-3 px-md-5 me-3 border-radius" routerLink="/services">Our Services</a>
                        </div>
                    </div><!-- end row -->
                </div><!-- end container -->
            </div>
        </div>
    </ng-template>
</owl-carousel-o>
<!-- end owl-carousel -->

<!-- Facts Start -->
<div class="container-fluid facts py-5 pt-lg-0">
    <div class="container py-5 pt-lg-0">
        <div class="row gx-0">
            <!-- Facts Loop -->
            <div *ngFor="let fact of facts; let i = index" class="col-lg-4">
                <div class="shadow d-flex align-items-center justify-content-center p-4" [ngClass]="getBackgroundClass(fact.position)" style="height: 150px;">
                    
                    <!-- Icon Container -->
                    <div class="d-flex align-items-center justify-content-center border-radius" style="width: 60px; height: 60px;" [ngClass]="getIconBgClass(fact.iconBg)">
                        <i  class="bi fs-4" [ngClass]="[fact.icon, getIconColorClass(fact.iconBg)]"></i>
                    </div>
                    
                    <!-- Text Content -->
                    <div class="ps-4">
                        <h5 class="mb-0" [ngClass]="getTextColorClass(fact.textColor)">
                            {{ fact.title }}
                        </h5>
                        <h1 class="mb-0" [ngClass]="getTextColorClass(fact.textColor)">
                            {{ fact.value | number }}
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Facts End -->

<!-- About Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="row g-5">
            <div class="col-lg-7">
                <div class="section-title position-relative pb-3 mb-5">
                    <h5 class="fw-bold text-primary text-uppercase">About Us</h5>
                    <h1 class="mb-0">Empowering Brands with Creative & Digital Excellence</h1>
                </div>
                <p class="mb-4">We're a creative agency focused on branding, UI/UX, and digital storytelling. From concept to
                    execution, we design experiences that connect and inspire. Our team crafts solutions that are both visually
                    stunning and performance-driven.</p>
                <div class="row g-0 mb-3">
                    <div class="col-sm-6">
                        <h5 class="mb-3"><i class="bi bi-award text-primary me-3"></i>Design Awards</h5>
                        <h5 class="mb-3"><i class="bi bi-people text-primary me-3"></i>Creative Team</h5>
                    </div>
                    <div class="col-sm-6">
                        <h5 class="mb-3"><i class="bi bi-lightning-charge text-primary me-3"></i>Fast Delivery</h5>
                        <h5 class="mb-3"><i class="bi bi-cash-coin text-primary me-3"></i>Transparent Pricing</h5>
                    </div>
                </div>
                <div class="d-flex align-items-center mb-4">
                    <div class="bg-primary d-flex align-items-center justify-content-center border-radius"
                        style="width: 60px; height: 60px;">
                        <i class="bi bi-telephone-fill text-white fs-5"></i>
                    </div>
                    <div class="ps-4">
                        <h5 class="mb-2">Call Us to Start Your Project</h5>
                        <h4 class="text-primary mb-0">+1 234 5577889</h4>
                    </div>
                </div>
                <a routerLink="/contact" class="btn btn-primary border-radius py-3 px-5 mt-3">Get a Quote</a>
            </div>

            <div class="col-lg-5" style="min-height: 500px;">
                <div class="position-relative h-100">
                    <img class="position-absolute w-100 h-100 border-radius" src="assets/images/about.jpg" style="object-fit: cover;" alt="about-img">
                </div>
            </div>
        </div>
    </div>
</div>
<!-- About End -->

<!-- Features Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Why Choose Us</h5>
            <h1 class="mb-0">We Help Brands Stand Out with Stunning Design & Strategy</h1>
        </div>
        <div class="row g-5">
           <!-- LEFT FEATURES -->
            <div class="col-lg-4">
                <div class="row g-5">
                    <div class="col-12" *ngFor="let feature of leftFeatures">
                        <div class="bg-primary border-radius d-flex align-items-center justify-content-center mb-3"
                            style="width: 60px; height: 60px;">
                            <i class="bi text-white fs-4" [ngClass]="feature.icon"></i>
                        </div>
                        <h4>{{feature.title}}</h4>
                        <p class="mb-0">{{feature.desc}}</p>
                    </div>
                </div>
            </div>
            <!-- CENTER IMAGE -->
            <div class="col-lg-4" style="min-height: 350px;">
                <div class="position-relative h-100">
                    <img class="position-absolute w-100 h-100 border-radius wow zoomIn" src="assets/images/feature.jpg"
                        style="object-fit: cover;" alt="feature-img">
                </div>
            </div>
            <!-- RIGHT FEATURES -->
            <div class="col-lg-4">
                <div class="row g-5">
                    <div class="col-12" *ngFor="let feature of rightFeatures">
                        <div class="bg-primary border-radius d-flex align-items-center justify-content-center mb-3"
                            style="width: 60px; height: 60px;">
                            <i class="bi text-white fs-4" [ngClass]="feature.icon"></i>
                        </div>
                        <h4>{{feature.title}}</h4>
                        <p class="mb-0">{{feature.desc}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Features Start -->

<!-- Service Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Our Services</h5>
            <h1 class="mb-0">Creative Solutions to Elevate Your Brand Identity</h1>
        </div>
        <div class="row g-5">
            <!-- Services -->
            <div class="col-lg-4 col-md-6" *ngFor="let service of services">

                <div class="service-item bg-light border-radius d-flex flex-column align-items-center justify-content-center text-center">
                    <div class="service-icon border-radius">
                        <i class="bi text-white" [ngClass]="service.icon"></i>
                    </div>
                    <h4 class="mb-3">
                        {{service.title}}
                    </h4>
                    <p class="m-0">
                        {{service.desc}}
                    </p>
                    <a class="btn btn-lg btn-primary border-radius" routerLink="/services">
                        <i class="bi bi-arrow-right"></i>
                    </a>
                </div>

            </div>
            <!-- CTA Card -->
            <div class="col-lg-4 col-md-6">
                <div class="position-relative bg-primary border-radius h-100 d-flex flex-column align-items-center justify-content-center text-center p-5">
                
                <h3 class="text-white mb-3">Let's Work Together</h3>
                
                <p class="text-white mb-3">
                    Let us bring your brand vision to life with thoughtful design and creative storytelling.
                </p>
                
                <h2 class="text-white mb-0">
                    +1 300 1234567
                </h2>

                </div>
            </div>
        </div>
    </div>
</div>
<!-- Service End -->

<!-- Pricing Plan Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Pricing Plans</h5>
            <h1 class="mb-0">Affordable Creative Packages Tailored to Your Business</h1>
        </div>
        <div class="row g-0">
            <div class="col-lg-4" *ngFor="let plan of plans">
                <div class="border-radius" [ngClass]="plan.highlight ? 'bg-white shadow position-relative' : 'bg-light'">

                <div class="border-bottom py-4 px-5 mb-4">
                    <h4 class="text-primary mb-1">
                        {{plan.name}}
                    </h4>
                    <small class="text-uppercase">
                        {{plan.subtitle}}
                    </small>
                </div>

                <div class="p-5 pt-0">

                    <h1 class="display-5 mb-3">
                        <small class="align-top" style="font-size:22px; line-height:45px;">$</small>
                        {{plan.price}}.00
                        <small class="align-bottom" style="font-size:16px; line-height:40px;">/ Project</small>
                    </h1>

                    <!-- Features -->
                    <div class="d-flex justify-content-between mb-3" *ngFor="let feature of plan.features">
                        <span>{{feature.text}}</span>
                        <i class="fa pt-1"
                            [ngClass]="feature.available ? 'fa-check text-primary' : 'fa-times text-danger'">
                        </i>
                    </div>
                    <a routerLink="/pricing-table" class="btn btn-primary py-2 px-4 mt-4 border-radius">Get Started</a>
                </div>

                </div>

            </div>
        </div>
    </div>
</div>
<!-- Pricing Plan End -->

<!-- Quote Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="row g-5">
            <!-- Left Content -->
            <div class="col-lg-7">
                <div class="section-title position-relative pb-3 mb-5">
                    <h5 class="fw-bold text-primary text-uppercase">Request A Quote</h5>
                    <h1 class="mb-0">Let's Build Something Creative Together</h1>
                </div>
                <div class="row gx-3">
                    <div class="col-sm-6">
                        <h5 class="mb-4"><i class="fa fa-reply text-primary me-3"></i>We usually respond within 1 hour
                        </h5>
                    </div>
                    <div class="col-sm-6">
                        <h5 class="mb-4"><i class="fa fa-phone-alt text-primary me-3"></i>Instant project consultation
                        </h5>
                    </div>
                </div>
                <p class="mb-4">Got a project in mind? Whether it's a new brand identity, website design, or digital
                    campaign we're ready to turn your ideas into reality. Let's discuss how we can help bring your
                    vision to life.</p>
                <div class="d-flex align-items-center mt-2 wow zoomIn" data-wow-delay="0.6s">
                    <div class="bg-primary d-flex align-items-center justify-content-center border-radius"
                        style="width: 60px; height: 60px;">
                        <i class="fa fa-phone-alt text-white"></i>
                    </div>
                    <div class="ps-4">
                        <h5 class="mb-2">Call us to discuss your idea</h5>
                        <h4 class="text-primary mb-0">+012 345 6789</h4>
                    </div>
                </div>
            </div>

            <!-- Quote Form -->
            <div class="col-lg-5">
                <div class="bg-primary border-radius h-100 d-flex align-items-center p-5">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row g-3">
                            <div class="col-xl-12">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input class="border-radius" type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched"
                                        name="user_name" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <input type="email" minlength="2" maxlength="35" [class.is-invalid]="userEmail.invalid && userEmail.touched"
                                        name="user_email" class="md-input border-radius" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                        #userEmail="ngModel" required email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <select class="form-select bg-light border-radius form-control">
                                    <option selected>Select a Service</option>
                                    <option value="branding">Branding & Logo Design</option>
                                    <option value="web">Website Design</option>
                                    <option value="uiux">UI/UX Design</option>
                                    <option value="marketing">Digital Marketing</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="visually-hidden" for="message">Project Details</label>
                                    <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea border-radius"
                                        id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                                        required></textarea>
                                    <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                        Project details are required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <button class="btn btn-dark w-100 fw-medium py-3 border-radius" type="submit" name="submit" [disabled]="contactForm.invalid" value="Get Quote">Get Quote</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Quote End -->

<!-- Testimonial Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-4 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Testimonials</h5>
            <h1 class="mb-0">What Our Clients Say About Working With Us</h1>
        </div>
        <owl-carousel-o [options]="testimonialCarousel" class="owl-btn-center-lr testimonial-carousel mrt-80">
          <ng-template carouselSlide *ngFor="let client of clients">
            <!-- Testimonial box -->
            <div class="testimonial-item bg-light">
                <div class="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                    <img class="img-fluid border-radius" src="assets/images/{{client.image}}"
                        style="width: 60px; height: 60px;" alt="client-1">
                    <div class="ps-4">
                        <h4 class="text-primary mb-1">{{client.title}}</h4>
                        <small class="text-uppercase">{{client.subtitle}}</small>
                    </div>
                </div>
                <div class="pt-4 pb-5 px-5">
                    {{client.desc}}
                </div>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div>
<!-- Testimonial End -->

<!-- Team Start -->
<div class="container-fluid py-5">
  <div class="container py-5">

    <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
      <h5 class="fw-bold text-primary text-uppercase">Team Members</h5>
      <h1 class="mb-0">Meet the Creative Minds Behind Our Success</h1>
    </div>

    <div class="row g-5">

      <div class="col-lg-4" *ngFor="let member of teamMembers; let i = index" [attr.data-wow-delay]="(i+1)*0.3 + 's'">

        <div class="team-item bg-light border-radius overflow-hidden">

          <div class="team-img position-relative overflow-hidden">

            <img class="img-fluid w-100"
                 [src]="'assets/images/' + member.image"
                 [alt]="member.name">

            <div class="team-social">

              <a *ngFor="let social of member.socials"
                 class="btn btn-lg btn-primary btn-lg-square border-radius"
                 [href]="social.link">

                <i [class]="social.icon + ' fw-normal'"></i>

              </a>

            </div>

          </div>

          <div class="text-center py-4">
            <h4 class="text-primary">{{member.name}}</h4>
            <p class="text-uppercase m-0">{{member.role}}</p>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>
<!-- Team End -->

<!-- Blog Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Latest Blog</h5>
            <h1 class="mb-0">Explore Insights, Trends & Tips from Our Experts</h1>
        </div>
        <div class="row g-5">
            <div class="col-lg-4" *ngFor="let blog of blogs">
                <div class="blog-item bg-light border-radius overflow-hidden">
                    <div class="blog-img position-relative overflow-hidden">

                        <img class="img-fluid"
                            [src]="'assets/images/' + blog.image"
                            [alt]="blog.title">

                        <a class="position-absolute top-0 start-0 bg-primary text-white border-radius-end mt-5 py-2 px-4"
                            routerLink="/blog-grid">
                            {{blog.category}}
                        </a>

                    </div>
                    <div class="p-4">

                        <div class="d-flex mb-3">
                        <small class="me-3">
                            <i class="far fa-user text-primary me-2"></i>
                            {{blog.author}}
                        </small>

                        <small>
                            <i class="far fa-calendar-alt text-primary me-2"></i>
                            {{blog.date}}
                        </small>
                        </div>

                        <h4 class="mb-3">
                            {{blog.title}}
                        </h4>

                        <p>
                            {{blog.desc}}
                        </p>

                        <a class="text-uppercase" routerLink="/blog-details">
                            Read More
                            <i class="bi bi-arrow-right"></i>
                        </a>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Blog Start -->

<!-- Brands Start -->
<div class="container-fluid">
    <div class="container py-5 mb-5">
        <div class="bg-white">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr vendor-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a href="#."><img src="assets/images/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- Brands End -->